const BAR_ID = 'nb-top-loader';
const STYLE_ID = 'nb-top-loader-style';

const HEIGHT = 2;
const MIN_WIDTH = 736;
const MIN_VISIBLE = 260;
const SAFETY_MS = 8000;

const CRAWL = 'transform 12s cubic-bezier(0.08, 0.82, 0.17, 1)';
const SETTLE = 'transform 0.22s cubic-bezier(0.4, 0, 0.2, 1)';
const CEILING = 0.9;

let bar = null;
let hideTimer = null;
let safety = null;
let installed = false;
let startedAt = 0;

const styles = `
  #${BAR_ID} {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: ${HEIGHT}px;
    z-index: 2147483646;
    pointer-events: none;
    background: var(--theme-ui-colors-articleText, #09090b);
    transform: scaleX(0);
    transform-origin: 0 50%;
    opacity: 0;
    will-change: transform, opacity;
    transition: opacity 0.2s ease-out;
  }

  #${BAR_ID}[data-active="true"] {
    opacity: 1;
  }

  @media (max-width: ${MIN_WIDTH - 1}px) {
    #${BAR_ID} {
      display: none;
    }
  }

`;

const ensureBar = () => {
  if (typeof document === 'undefined') return null;
  if (bar && bar.isConnected) return bar;

  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = styles;
    document.head.appendChild(style);
  }

  bar = document.getElementById(BAR_ID);

  if (!bar) {
    bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
  }

  return bar;
};

const paint = (value, easing) => {
  if (!bar) return;
  bar.style.transitionProperty = easing ? 'transform, opacity' : 'opacity';
  if (easing) bar.style.transition = `${easing}, opacity 0.2s ease-out`;
  bar.style.transform = `scaleX(${value})`;
};

const clearTimers = () => {
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
  if (safety) {
    clearTimeout(safety);
    safety = null;
  }
};

export const startTopLoader = () => {
  if (typeof window === 'undefined') return;
  if (window.innerWidth < MIN_WIDTH) return;

  const element = ensureBar();
  if (!element) return;

  clearTimers();
  startedAt = Date.now();

  element.setAttribute('data-active', 'false');
  element.style.transition = 'none';
  element.style.transform = 'scaleX(0)';

  void element.offsetWidth;

  element.setAttribute('data-active', 'true');
  paint(CEILING, CRAWL);

  safety = setTimeout(finishTopLoader, SAFETY_MS);
};

export const finishTopLoader = () => {
  if (typeof window === 'undefined') return;
  if (!bar || bar.getAttribute('data-active') !== 'true') return;

  clearTimers();

  const elapsed = Date.now() - startedAt;
  const wait = Math.max(0, MIN_VISIBLE - elapsed);

  hideTimer = setTimeout(() => {
    paint(1, SETTLE);

    hideTimer = setTimeout(() => {
      if (bar) bar.setAttribute('data-active', 'false');

      hideTimer = setTimeout(() => {
        if (bar) {
          bar.style.transition = 'none';
          bar.style.transform = 'scaleX(0)';
          void bar.offsetWidth;
        }
      }, 220);
    }, 150);
  }, wait);
};

const isHome = pathname => pathname.replace(/\/+$/, '') === '';

const navigatesAway = event => {
  if (event.defaultPrevented) return false;
  if (event.button !== 0) return false;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;

  const anchor = event.target.closest && event.target.closest('a[href]');
  if (!anchor) return false;
  if (anchor.target && anchor.target !== '_self') return false;
  if (anchor.hasAttribute('download')) return false;

  const url = new URL(anchor.href, window.location.href);
  if (url.origin !== window.location.origin) return false;

  if (isHome(url.pathname)) return false;

  return url.pathname !== window.location.pathname;
};


export const installTopLoader = () => {
  if (typeof window === 'undefined' || installed) return;
  installed = true;

  document.addEventListener(
    'click',
    event => {
      if (navigatesAway(event)) startTopLoader();
    },
    true,
  );

  window.addEventListener('popstate', () => {
    if (!isHome(window.location.pathname)) startTopLoader();
  });
};
